import Breadcrumb from '@/components/base/Breadcrumb';
import RelatedPages from '@/components/base/RelatedPages';

export default function ContactInfoContent() {
  return (
    <>
      {/* Hero */}
      <section
        className="relative pt-24 pb-16 bg-cover bg-top"
        style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=natural%20green%20office%20entrance%20building%20exterior%20with%20lush%20plants%20clean%20minimalist%20architecture%20soft%20morning%20sunlight%20warm%20inviting%20biotech%20company%20facade%20nature%20inspired%20design%20serene%20environment&width=1600&height=560&seq=contact-info-hero&orientation=landscape')" }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/28 to-black/45" />
        <div className="relative max-w-screen-xl mx-auto px-6 lg:px-10">
          <Breadcrumb
            items={[
              { label: '首頁', href: '/' },
              { label: '聯絡我們', href: '/contact' },
              { label: '聯絡資訊' },
            ]}
            className="mb-4 text-white/60"
          />
          <span className="inline-block bg-white/20 backdrop-blur-sm text-white text-[0.8125rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-white/30">
            聯絡我們
          </span>
          <h1 className="text-white font-bold text-[2.25rem] md:text-[3rem] leading-tight mb-4 max-w-2xl">
            聯絡資訊
          </h1>
          <p className="text-white/85 text-[1.0625rem] leading-[1.8] max-w-xl">
            歡迎透過以下方式聯繫康永生技，無論電話、Email 或 LINE，我們都樂意為您服務。
          </p>
          <div className="mt-6 h-0.5 w-14 bg-[#81C784] rounded-full" />
        </div>
      </section>

      {/* Quick contact CTA row */}
      <div className="bg-[#f7faf7] border-b border-gray-100">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 py-5">
          <div className="flex flex-col sm:flex-row flex-wrap gap-3">
            <a
              href="https://lin.ee/X7Hcpf4"
              rel="nofollow"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[0.9375rem] px-6 py-3 rounded-full transition-all duration-300 cursor-pointer w-full sm:w-auto"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-line-fill text-base" />
              </div>
              加入 LINE 官方帳號
            </a>
            <a
              href="tel:04-22029858"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-green-50 font-semibold text-[0.9375rem] px-6 py-3 rounded-full transition-all duration-300 cursor-pointer w-full sm:w-auto"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-base" />
              </div>
              電話聯絡
            </a>
            <a
              href="mailto:natural1070606@gmail.com"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 border border-gray-300 text-[#1a2e1a] hover:border-[#4CAF50] hover:text-[#4CAF50] font-semibold text-[0.9375rem] px-6 py-3 rounded-full transition-all duration-300 cursor-pointer w-full sm:w-auto"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line text-base" />
              </div>
              Email 聯絡
            </a>
          </div>
        </div>
      </div>

      {/* Main content */}
      <section className="py-16 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-10 xl:gap-14">

            {/* ── 左側：聯絡資訊卡片 ── */}
            <div className="w-full lg:flex-1 space-y-5">
              <div>
                <h2 className="text-[#1a2e1a] font-bold text-[1.5rem] mb-1.5">公司聯絡方式</h2>
                <p className="text-gray-500 text-[0.9375rem] leading-[1.75]">
                  康永生技有限公司 歡迎各種合作洽詢，請選擇您方便的聯絡方式。
                </p>
              </div>

              {/* Company name + address */}
              <div className="bg-[#f7faf7] rounded-2xl p-6 border border-gray-100">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center bg-green-50 rounded-xl flex-shrink-0 border border-green-100">
                    <i className="ri-building-2-line text-[#4CAF50] text-xl" />
                  </div>
                  <div>
                    <p className="text-gray-400 text-[0.75rem] mb-1">公司名稱 &amp; 地址</p>
                    <p className="text-[#1a2e1a] font-bold text-[1.0625rem] leading-tight">康永生技有限公司</p>
                    <p className="text-gray-500 text-[0.875rem] mb-2">Kang Yong Biotech Ltd.</p>
                    <div className="flex items-start gap-2">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-map-pin-2-line text-[#4CAF50] text-sm" />
                      </div>
                      <p className="text-[#1a2e1a] font-semibold text-[0.9375rem]">台中市北區中清路一段79號6樓</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Phone */}
              <div className="bg-[#f7faf7] rounded-2xl p-6 border border-gray-100">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center bg-green-50 rounded-xl flex-shrink-0 border border-green-100">
                    <i className="ri-phone-line text-[#4CAF50] text-xl" />
                  </div>
                  <div className="flex-1">
                    <p className="text-gray-400 text-[0.75rem] mb-1">聯絡電話</p>
                    <a
                      href="tel:04-22029858"
                      className="text-[#1a2e1a] font-bold text-[1.25rem] hover:text-[#4CAF50] transition-colors cursor-pointer"
                    >
                      (04)-22029858
                    </a>
                    <p className="text-gray-500 text-[0.8125rem] mt-1">週一至週五 09:00 – 18:00 ｜ 週六 09:00 – 12:00</p>
                    <a
                      href="tel:04-22029858"
                      className="whitespace-nowrap inline-flex items-center gap-1.5 mt-3 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[0.875rem] px-5 py-2 rounded-full transition-all duration-300 cursor-pointer"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-phone-line text-sm" />
                      </div>
                      立即撥打
                    </a>
                  </div>
                </div>
              </div>

              {/* Email */}
              <div className="bg-[#f7faf7] rounded-2xl p-6 border border-gray-100">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center bg-green-50 rounded-xl flex-shrink-0 border border-green-100">
                    <i className="ri-mail-line text-[#4CAF50] text-xl" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-gray-400 text-[0.75rem] mb-1">電子郵件</p>
                    <a
                      href="mailto:natural1070606@gmail.com"
                      className="text-[#1a2e1a] font-bold text-[1.0625rem] hover:text-[#4CAF50] transition-colors cursor-pointer break-all"
                    >
                      natural1070606@gmail.com
                    </a>
                    <p className="text-gray-500 text-[0.8125rem] mt-1">來信後我們將於一個工作天內回覆</p>
                    <a
                      href="mailto:natural1070606@gmail.com"
                      className="whitespace-nowrap inline-flex items-center gap-1.5 mt-3 border border-[#4CAF50] text-[#4CAF50] hover:bg-green-50 font-semibold text-[0.875rem] px-5 py-2 rounded-full transition-all duration-300 cursor-pointer"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-mail-send-line text-sm" />
                      </div>
                      寄送 Email
                    </a>
                  </div>
                </div>
              </div>

              {/* LINE */}
              <div className="bg-[#e8f5e9] border border-[#c8e6c9] rounded-2xl p-6">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center bg-[#4CAF50] rounded-xl flex-shrink-0">
                    <i className="ri-line-fill text-white text-xl" />
                  </div>
                  <div className="flex-1">
                    <p className="text-gray-500 text-[0.75rem] mb-1">LINE 官方帳號</p>
                    <p className="text-[#1a2e1a] font-bold text-[1.0625rem]">@126uwznp</p>
                    <p className="text-gray-600 text-[0.875rem] mt-1 leading-[1.7]">
                      歡迎加入 LINE 官方帳號，享受更即時便捷的服務，可諮詢 ODM / OEM 合作與產品開發相關問題。
                    </p>
                    <a
                      href="https://lin.ee/X7Hcpf4"
                      rel="nofollow"
                      className="whitespace-nowrap inline-flex items-center gap-2 mt-3 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[0.9375rem] px-6 py-2.5 rounded-full transition-all duration-300 cursor-pointer"
                    >
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-line-fill text-base" />
                      </div>
                      立即加入 LINE
                    </a>
                  </div>
                </div>
              </div>

              {/* Business hours */}
              <div className="bg-[#f7faf7] rounded-2xl p-6 border border-gray-100">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-time-line text-[#4CAF50] text-lg" />
                  </div>
                  <h3 className="text-[#1a2e1a] font-bold text-[1rem]">服務時間</h3>
                </div>
                <div className="space-y-3">
                  {[
                    { day: '週一至週五', time: '09:00 – 18:00', active: true },
                    { day: '週六', time: '09:00 – 12:00', active: true },
                    { day: '週日及國定假日', time: '公休', active: false },
                  ].map((row) => (
                    <div key={row.day} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                      <span className="text-gray-600 text-[0.9rem]">{row.day}</span>
                      <span className={`font-semibold text-[0.9rem] ${row.active ? 'text-[#1a2e1a]' : 'text-gray-400'}`}>
                        {row.time}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* ── 右側：Google Map + 交通 + CTA ── */}
            <div className="w-full lg:w-[500px] xl:w-[540px] flex-shrink-0 space-y-6">
              <div>
                <h2 className="text-[#1a2e1a] font-bold text-[1.5rem] mb-1.5">公司位置</h2>
                <p className="text-gray-500 text-[0.9375rem] flex items-center gap-1.5">
                  <i className="ri-map-pin-line text-[#4CAF50]" />
                  台中市北區中清路一段79號6樓
                </p>
              </div>

              {/* Google Map iframe */}
              <div className="rounded-2xl overflow-hidden border border-gray-200" style={{ minHeight: '300px' }}>
                <iframe
                  title="康永生技有限公司 Google 地圖位置"
                  src="https://maps.google.com/maps?q=%E5%8F%B0%E4%B8%AD%E5%B8%82%E5%8C%97%E5%8D%80%E4%B8%AD%E6%B8%85%E8%B7%AF%E4%B8%80%E6%AE%B379%E8%99%9F6%E6%A8%93&hl=zh-TW&z=16&output=embed"
                  width="100%"
                  height="400"
                  style={{ border: 0, display: 'block' }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="w-full h-[300px] md:h-[400px]"
                />
              </div>

              {/* Map action row */}
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                <p className="text-gray-400 text-[0.8125rem] flex items-center gap-1.5 flex-1 min-w-0">
                  <i className="ri-map-pin-2-line text-[#4CAF50] flex-shrink-0" />
                  <span className="truncate">台中市北區中清路一段79號6樓</span>
                </p>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=%E5%8F%B0%E4%B8%AD%E5%B8%82%E5%8C%97%E5%8D%80%E4%B8%AD%E6%B8%85%E8%B7%AF%E4%B8%80%E6%AE%B379%E8%99%9F6%E6%A8%93"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="whitespace-nowrap inline-flex items-center gap-1.5 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[0.875rem] px-5 py-2.5 rounded-full transition-all duration-300 cursor-pointer flex-shrink-0"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line text-sm" />
                  </div>
                  在 Google 地圖中開啟
                </a>
              </div>

              {/* How to reach */}
              <div className="bg-[#f7faf7] rounded-2xl p-6 border border-gray-100">
                <h3 className="text-[#1a2e1a] font-bold text-[1rem] mb-4 flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-route-line text-[#4CAF50] text-base" />
                  </div>
                  交通方式
                </h3>
                <div className="space-y-4">
                  {[
                    { icon: 'ri-car-line', label: '自行開車', desc: '由中清路一段往北行駛，抵達79號後進入大樓，搭乘電梯至6樓。' },
                    { icon: 'ri-bus-line', label: '公車', desc: '搭乘途經中清路之公車，於中清路一段站下車後步行可達。' },
                  ].map((item) => (
                    <div key={item.label} className="flex items-start gap-3">
                      <div className="w-7 h-7 flex items-center justify-center bg-white rounded-lg border border-gray-200 flex-shrink-0 mt-0.5">
                        <i className={`${item.icon} text-[#4CAF50] text-sm`} />
                      </div>
                      <div>
                        <p className="text-[#1a2e1a] font-semibold text-[0.875rem]">{item.label}</p>
                        <p className="text-gray-500 text-[0.8125rem] leading-[1.7]">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* CTA form link */}
              <div className="bg-[#1a2e1a] rounded-2xl p-6 text-white">
                <h3 className="font-bold text-[1.125rem] mb-2">有具體合作需求？</h3>
                <p className="text-white/75 text-[0.875rem] leading-[1.75] mb-4">
                  填寫線上諮詢表單，我們將在一個工作天內主動與您聯繫，協助評估最適合的合作方向。
                </p>
                <a
                  href="/contact/form"
                  className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[0.9375rem] px-6 py-3 rounded-full transition-all duration-300 cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-file-text-line text-base" />
                  </div>
                  前往填寫諮詢表單
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>

      <RelatedPages items={[
        { title: '聯絡表單', desc: '填寫線上諮詢表單，一個工作天內由專人與您聯繫。', href: '/contact/form' },
        { title: '合作流程', desc: '從需求對焦到完成交貨，了解清楚可控的合作步驟。', href: '/cooperation/process' },
        { title: '常見問題', desc: '品牌、起訂量、法規、通路…常見答疑全整理。', href: '/cooperation/faq' },
      ]} />
    </>
  );
}
